import { render, staticRenderFns } from "./SavedQueries.vue?vue&type=template&id=59810f78&scoped=true&"
import script from "./SavedQueries.vue?vue&type=script&lang=js&"
export * from "./SavedQueries.vue?vue&type=script&lang=js&"
import style0 from "./SavedQueries.vue?vue&type=style&index=0&id=59810f78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59810f78",
  null
  
)

export default component.exports